export default __webpack_public_path__ + "static/media/certificate.7e40a3d7.png";